import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';
import { LogLevelStrings } from 'q2-tecton-sdk/src/types/index';

export default function logToServer(platformCapabilities: Set<string>, moduleId: string) {
    if (!platformCapabilities.has('logToServer')) {
        return;
    }
    return function(message: string, level: LogLevelStrings = 'info') {
        sendMessage(
            'logToServer',
            Maybe.just(
                JSON.stringify({
                    moduleId,
                    message,
                    level
                })
            )
        );
    };
}
